import React from "react";
import { Box, Grid, Card, CardActionArea, CardContent, Typography } from "@mui/material";
import {
    Warning as IncidentIcon,
    Folder as ProjectIcon,
    SensorDoor as DoorServiceIcon,
    SettingsInputAntenna as RFTestIcon,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const reportItems = [
    {
        title: "Incident Report",
        desc: "Document and review workplace incidents.",
        path: "/reports/incident",
        icon: IncidentIcon,
    },
    {
        title: "Project Report",
        desc: "Summarize project status and progress.",
        path: "/reports/project",
        icon: ProjectIcon,
    },
    {
        title: "Door Service Report",
        desc: "Log door service and maintenance visits.",
        path: "/reports/door-service",
        icon: DoorServiceIcon,
    },
    {
        title: "RF Test Report",
        desc: "Record RF leakage test results.",
        path: "/reports/rf-test",
        icon: RFTestIcon,
    },
];

export default function Reports() {
    const navigate = useNavigate();

    return (
        <Box>
            <Grid container spacing={2}>
                {reportItems.map(({ title, desc, path, icon: Icon }) => (
                    <Grid item xs={6} key={path}>
                        <Card
                            sx={{
                                height: "100%",
                                boxShadow: "none",
                                border: 1,
                                borderColor: "primary.main",
                            }}
                        >
                            <CardActionArea
                                onClick={() => navigate(path)}
                                sx={{ height: "100%", alignItems: "flex-start" }}
                            >
                                <CardContent>
                                    <Box sx={{ mb: 1 }}>
                                        <Icon color="primary" fontSize="medium" />
                                    </Box>
                                    <Typography
                                        variant="subtitle2"
                                        sx={{
                                            fontFamily: "Montserrat, sans-serif",
                                            fontWeight: 700,
                                            lineHeight: 1.3,
                                            mb: 0.5,
                                        }}
                                    >
                                        {title}
                                    </Typography>
                                    <Typography variant="caption" color="text.secondary">
                                        {desc}
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
}
